import { render, staticRenderFns } from "./modal-post.vue?vue&type=template&id=b49a3cd8&scoped=true&"
import script from "./modal-post.vue?vue&type=script&lang=js&"
export * from "./modal-post.vue?vue&type=script&lang=js&"
import style0 from "./modal-post.vue?vue&type=style&index=0&id=b49a3cd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b49a3cd8",
  null
  
)

export default component.exports